<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('heading')">
      <h1 :class="b('title')">{{ $t("Настройки") }}</h1>
      <p :class="b('subtitle')">
        {{
          $t("Верификация аккаунта, тест знаний рынка и платежные реквизиты")
        }}
      </p>
    </div>

    <SettingsTabs :class="b('tabs')" :tab="tab" @update:tab="tabChange" />

    <Transition name="settings-panel" mode="out-in">
      <component :is="displayedComponent" :key="tab" />
    </Transition>
  </div>
</template>
